import { FSSdkStatus, FLAG_VISITOR_EXPOSED, METHOD_DEACTIVATED_ERROR, FLAG_METADATA, METADATA_PANIC_MODE } from '../enum/index';
import { logInfoSprintf } from '../utils/utils';
import { DefaultStrategy } from './DefaultStrategy';
import { FSFlagMetadata } from '../flag/FSFlagMetadata';
export class PanicStrategy extends DefaultStrategy {
    setConsent(hasConsented) {
        this.visitor.hasConsented = hasConsented;
    }
    updateContext() {
        this.log('updateContext');
    }
    clearContext() {
        this.log('clearContext');
    }
    async lookupHits() {
        //
    }
    async lookupVisitor() {
        //
    }
    async cacheVisitor() {
        //
    }
    async cacheHit() {
        //
    }
    fetchCampaignsFromCache() {
        return [];
    }
    sendVisitorAllocatedVariations() {
        //
    }
    async sendHit(_hit) {
        this.log('sendHit');
    }
    async sendHits(_hits) {
        this.log('sendHits');
    }
    getFlagValue(param) {
        this.log('Flag.value');
        return param.defaultValue;
    }
    async visitorExposed() {
        this.log(FLAG_VISITOR_EXPOSED);
    }
    getFlagMetadata(param) {
        const emptyMetaData = FSFlagMetadata.Empty();
        logInfoSprintf(this.config, FLAG_METADATA, METADATA_PANIC_MODE, this.visitor.visitorId, param.key, emptyMetaData);
        return emptyMetaData;
    }
    async sendTroubleshootingHit() {
        //
    }
    async sendSdkConfigAnalyticHit() {
        //
    }
    async sendActivate(_flagDto, _defaultValue) {
        //
    }
    async collectEAIEventsAsync() {
        this.log('collectEAIData');
    }
    reportEaiPageView() {
        //
    }
    reportEaiVisitorEvent() {
        //
    }
    onEAICollectStatusChange() {
        //
    }
    async addInTrackingManager() {
        //
    }
    log(methodName) {
        logInfoSprintf(this.config, methodName, METHOD_DEACTIVATED_ERROR, this.visitor.visitorId, methodName, FSSdkStatus[FSSdkStatus.SDK_PANIC]);
    }
}
